import React from 'react';

/** Literal, case-insensitive search presentation for plain text. */
export default function HighlightedText({ text, query }) {
  const search = query?.trim();
  if (!search) return text;
  const expression = new RegExp(`(${search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
  return <>{text.split(expression).map((part, index) => index % 2
    ? <mark key={index} className="search-highlight bg-bun-warning-bg text-bun-text [&.current-search-match]:bg-bun-ink [&.current-search-match]:text-bun-on-ink">{part}</mark>
    : part)}</>;
}
